import * as React from "react";

function Lens(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="prefix__ionicon"
      viewBox="0 0 512 512"
      fill="none"
      {...props}
      width={34}
      height={34}
    >
      <path
        d="M221.09 64a157.09 157.09 0 10157.09 157.09A157.1 157.1 0 00221.09 64z"
        stroke="#ffff"
        strokeMiterlimit={10}
        strokeWidth={32}
      />
      <path
        stroke="#ffff"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={32}
        d="M338.29 338.29L448 448"
      />
    </svg>
  );
}

const MemoLens = React.memo(Lens);
export default MemoLens;
